import proj4 from "proj4"
import { forward as mgrsForward } from "mgrs"

export function isProjectedCoordinateAvailable(lat) {
  return Number(lat) >= -80 && Number(lat) <= 84
}

function utmZone(lat, lng) {
  let zone = Math.min(60, Math.floor((lng + 180) / 6) + 1)
  if (lat >= 56 && lat < 64 && lng >= 3 && lng < 12) zone = 32
  if (lat >= 72 && lat < 84) {
    if (lng >= 0 && lng < 9) zone = 31
    else if (lng >= 9 && lng < 21) zone = 33
    else if (lng >= 21 && lng < 33) zone = 35
    else if (lng >= 33 && lng < 42) zone = 37
  }
  return zone
}

function latitudeBand(lat) {
  if (!isProjectedCoordinateAvailable(lat)) return ""
  const bands = "CDEFGHJKLMNPQRSTUVWXX"
  return bands[Math.floor((lat + 80) / 8)]
}

export function formatUtm(lat, lng) {
  if (!isProjectedCoordinateAvailable(lat)) return "Unavailable outside 80°S–84°N"
  const zone = utmZone(lat, lng)
  const epsg = lat >= 0 ? `EPSG:326${String(zone).padStart(2, "0")}` : `EPSG:327${String(zone).padStart(2, "0")}`
  const [easting, northing] = proj4("EPSG:4326", epsg, [lng, lat])
  return `Zone ${zone}${latitudeBand(lat)} Easting: ${Math.round(easting)} Northing: ${Math.round(northing)}`
}

export function formatMgrs(lat, lng) {
  if (!isProjectedCoordinateAvailable(lat)) return "Unavailable outside 80°S–84°N"
  const compact = mgrsForward([lng, lat], 5)
  const match = compact.match(/^(\d{1,2}[C-HJ-NP-X])([A-Z]{2})(\d{5})(\d{5})$/)
  return match ? `${match[1]} ${match[2]} ${match[3]} ${match[4]}` : compact
}
